import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { FiscalStatusPill } from '../../models';

/** Píldora de estado (pantalla Fiscal, menú). Sin `pill` no pinta nada. */
@Component({
    selector: 'fina-fiscal-status-pill',
    templateUrl: './fiscal-status-pill.component.html',
    styleUrls: ['./fiscal-status-pill.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FiscalStatusPillComponent {
    @Input() pill: FiscalStatusPill | null = null;
    /** Versión compacta para el menú lateral. */
    @Input() small = false;
}
